<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-video-file`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.171 2a2 2 0 011.415.586l5.828 5.831A2 2 0 0142 9.831V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h26.171zM32 6H10v36h28V12.038l-5 .001a1 1 0 01-1-1L31.999 6zM19.23 19c.026 0 .05.006.075.007.027.002.054.004.08.008.216.026.413.102.578.22l10.282 5.646c.426.232.827.686.745 1.119.082.433-.32.887-.745 1.12l-10.282 5.645a1.257 1.257 0 01-.577.22 1.11 1.11 0 01-.081.008c-.025.001-.05.007-.075.007-.014 0-.029-.004-.043-.004a1.233 1.233 0 01-.182-.018c-.358-.067-.656-.252-.835-.544-.022-.037-.036-.075-.053-.112-.009-.02-.019-.037-.026-.056a1.137 1.137 0 01-.037-.112 1.199 1.199 0 01-.034-.142c-.01-.069-.019-.122-.019-.179V20.167c0-.057.01-.11.017-.165.01-.063.022-.11.036-.155a.932.932 0 01.037-.113c.007-.019.017-.037.026-.056.017-.037.031-.075.053-.111a1.19 1.19 0 01.802-.54c.093-.015.154-.022.215-.023.014 0 .029-.004.043-.004z"/></svg>
</template>
<script>

export default {
  name: 'IconVideoFile',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
